import { Maximize2, Building2, BarChart3, Shield, Sparkles, ChevronDown, AlertTriangle } from "lucide-react";
import { useState } from "react";
import PropertySchematic from "@/components/PropertySchematic";

const CAT_ICON = { spatial: Maximize2, unlockability: Building2, market: BarChart3, integrity: Shield };
const CAT_COLOR = {
  spatial: "text-cipher-green",
  unlockability: "text-blue-400",
  market: "text-cipher-gold",
  integrity: "text-amber-400",
};
const CAT_BORDER = {
  spatial: "border-l-cipher-green",
  unlockability: "border-l-blue-400",
  market: "border-l-cipher-gold",
  integrity: "border-l-amber-400",
};

export function WhatsDriving({ signals, floorAreaInsight, lens, sessionData }) {
  const top = (signals || []).slice(0, 3);
  const [showSchematic, setShowSchematic] = useState(false);

  // Combine floor area + conflict notes into one insight
  const hasFloorInsight = floorAreaInsight?.available;
  const floorCopy = hasFloorInsight ? (floorAreaInsight.copy?.[lens === "partner" ? "partner" : "public"] || floorAreaInsight.copy?.public) : null;
  const hasConflict = floorAreaInsight?.has_conflict;

  return (
    <div data-testid="section-whats-driving" className="space-y-3">
      {/* Combined signal insights */}
      {top.length > 0 && (
        <div className="bg-white/[0.04] border border-white/5 rounded-xl px-3.5 py-3 space-y-2" data-testid="combined-signals">
          <p className="text-[10px] text-white/30 uppercase tracking-wider mb-1">Key signals identified</p>
          {top.map((signal, idx) => {
            const Icon = CAT_ICON[signal.category] || Sparkles;
            const color = CAT_COLOR[signal.category] || "text-white/60";
            return (
              <div key={signal.id} className="flex items-start gap-2.5" data-testid={`driving-signal-${signal.id}`}>
                <Icon className={`w-3.5 h-3.5 mt-0.5 ${color} flex-shrink-0`} />
                <p className="text-xs text-white/70 leading-relaxed">{signal.short_copy}</p>
              </div>
            );
          })}
        </div>
      )}

      {top.length === 0 && (
        <p className="text-sm text-white/40 text-center py-4">
          No specific signals identified for this property.
        </p>
      )}

      {/* Combined property insight — floor area + conflict in one */}
      {hasFloorInsight && floorCopy && (
        <div className="bg-white/[0.03] border border-white/5 rounded-xl px-3.5 py-3" data-testid="combined-property-insight">
          <div className="flex items-start gap-2.5">
            <Maximize2 className="w-3.5 h-3.5 text-blue-400/60 mt-0.5 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-xs text-white/60 leading-relaxed">{floorCopy}</p>
              {hasConflict && (
                <div className="flex items-start gap-2 mt-2 pt-2 border-t border-white/5">
                  <AlertTriangle className="w-3 h-3 text-amber-400/50 mt-0.5 flex-shrink-0" />
                  <p className="text-[11px] text-amber-400/50 leading-relaxed">
                    Some details may differ from recorded data — this doesn't significantly affect the assessment.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
